import { DeliveryTypeCategory } from '@/features/orders/constants/app'
import {
    useFormCustomerAddressValue,
    useFormDeliveryTypeCategoryValue,
} from '@/features/pos/components/OrderFinalization/form'
import { DeliveryTimeOfferQuery } from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/PhoneModeFields/parts/DeliveryTimeSelector/queries'
import { DeliveryTimeOffer } from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/PhoneModeFields/parts/DeliveryTimeSelector/types'
import { transformDeliveryTimeOffer } from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/PhoneModeFields/parts/DeliveryTimeSelector/utils/transforms'
import { useHandleQueryErrorWithToast } from '@/features/pos/hooks/useHandleQueryErrorWithToast'
import { useQuery } from '@apollo/client'
import { useMemo } from 'react'

export const useDeliveryTimeOffer = (): DeliveryTimeOffer | undefined => {
    const deliveryTypeCategory = useFormDeliveryTypeCategoryValue()

    const address = useFormCustomerAddressValue()

    const { data, error, loading } = useQuery(DeliveryTimeOfferQuery, {
        variables: { deliveryTypeCategory, coordinates: address?.coordinates },
        skip:
            !deliveryTypeCategory ||
            (deliveryTypeCategory === DeliveryTypeCategory.Delivery && !address),
        fetchPolicy: 'cache-and-network',
    })

    useHandleQueryErrorWithToast(error, loading)

    return useMemo(() => {
        if (!data || (!data.deliveryTimeOffer.asap && !data.deliveryTimeOffer.timed))
            return undefined

        return transformDeliveryTimeOffer(data.deliveryTimeOffer)
    }, [data])
}
